import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiCall } from "../main/Apicall";
import ReusableTable from "../Reusablecomponents/ReusableTable";
import Pagination from "../Reusablecomponents/Pagination";
import ExportButton from "../Reusablecomponents/ExportButton";
import "../css/others/Table.css";
const Clientdetail: React.FC = () => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [showCreateClientButton, setShowCreateClientButton] = useState<boolean>(false);
  const navigate = useNavigate();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const fetchClients = useCallback(async () => {
    setLoading(true);
    try {
      const response = await apiCall("get", "/api/clients/all", undefined, { page: currentPage - 1, size: itemsPerPage });
      const { content, totalElements, totalPages } = response;
      setData(content);
      setTotalElements(totalElements);
      setTotalPages(totalPages);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }, [currentPage, itemsPerPage]);
  const fetchButtonVisibility = useCallback(async () => {
    try {
      const response = await apiCall("get", "/api/buttons/type-visible");
      const createClientConfig = response?.find((item: any) => item.type === "create-client-config" && item.visible === true);
      setShowCreateClientButton(!!createClientConfig);
    } catch (error) {
      console.error("Error fetching button visibility:", error);
      setShowCreateClientButton(false);
    }
  }, []);
  useEffect(() => { fetchClients() }, [fetchClients]);
  useEffect(() => { fetchButtonVisibility() }, [fetchButtonVisibility]);
  const fetchAllClients = useCallback(async () => {
    try {
      const response = await apiCall("get", "/api/clients/all", undefined, { page: 0, size: totalElements });
      return response.content || [];
    } catch (error) {
      console.error("Error fetching all clients for export:", error);
      return [];
    }
  }, [totalElements]);
  const handleCreateClient = () => navigate("/Createclient");
  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    try {
      const text = await file.text();
      const jsonData = JSON.parse(text);
      sessionStorage.setItem("uploadedClientData", JSON.stringify(jsonData));
      navigate("/Createclient");
    } catch (error) {
      console.error("Invalid JSON file", error);
      alert("Invalid JSON file. Please upload a valid client JSON.");
    }
  };
  const handleAccountIdClick = (rowData: any) => navigate(`/client-details/${rowData.clientId}`);
  const columns = [{ header: "Client Id", accessor: "clientId" }, { header: "Client Name", accessor: "clientName" }, { header: "Primary Spoc Name", accessor: "primarySpocName" }, { header: "Primary Spoc Email", accessor: "primarySpocEmail" }, { header: "Secondary Spoc Name", accessor: "secondarySpocName" }, { header: "Secondary Spoc Email", accessor: "secondarySpocEmail" }, { header: "Created By", accessor: "createdBy" }, { header: "Created Date", accessor: "createdDate" }, { header: "Updated By", accessor: "updatedBy" }, { header: "Updated Date", accessor: "updatedDate" }];
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Clients</h2>
        <div className="table-title-actions">
          {showCreateClientButton && (
            <button className="create-client-btn" onClick={handleCreateClient}>Create Client</button>
          )}
          <ExportButton data={data} columns={columns.map((col) => ({ key: col.accessor, label: col.header }))} fetchAllData={fetchAllClients} fileName="clients" />
        </div>
      </div>
      <input type="file" accept="application/json" ref={fileInputRef} className="hidden-input" onChange={handleFileChange} />
      {loading ? (
        <div className="spinner">Loading...</div>
      ) : (
        <>
          <ReusableTable
            columns={columns}
            data={data}
            clickableColumn="clientId"
            onRowClick={handleAccountIdClick}
          />
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalElements={totalElements}
            itemsPerPage={itemsPerPage}
            onPageChange={setCurrentPage}
            onItemsPerPageChange={setItemsPerPage}
          />
        </>
      )}
    </div>
  );
};
export default Clientdetail;